let started = false;

function surveyPath(pathname) {
  return (
    pathname.startsWith("/arbeidsmarktscan") ||
    pathname.includes("/perspectief-taxateurs/scan")
  );
}

function clearPendingNav() {
  if (!surveyPath(location.pathname)) return;
  if (typeof globalThis.Hologram?.dispatchAction !== "function") return;

  globalThis.Hologram.dispatchAction("clear_pending_nav", "page", {});
}

/** After Hologram restores a history snapshot, drop leftover next_page.
 * Needed for snapshots saved before hologram-clear-next-page-after-nav.patch.
 */
export function startClearPendingNavOnPopstate() {
  if (started) return;
  started = true;

  window.addEventListener("popstate", () => {
    // Hologram's popstate handler is async and mounts on rAF; wait two frames.
    requestAnimationFrame(() => {
      requestAnimationFrame(clearPendingNav);
    });
  });
}
